import { render, staticRenderFns } from "./asistencia.vue?vue&type=template&id=94372d5c&scoped=true&"
import script from "./asistencia.vue?vue&type=script&lang=js&"
export * from "./asistencia.vue?vue&type=script&lang=js&"
import style0 from "./asistencia.vue?vue&type=style&index=0&id=94372d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94372d5c",
  null
  
)

export default component.exports